import React from 'react';
import GradientBorder from '../../ui/GradientBorder';

const ButtonGreen = ({ name, w, icon, bg = 'bg-[#367567]', textColor = '', iconClassName = '', ...props }) => {
    return (
        <GradientBorder
            radiusBorder={'.25rem'}
            color2={'#367567'}
            color1={'#367567'}
            bg={bg}
            borderThickness="0px"
            // shadow="shadow-button-shadow"
            width={w}
        >
            <button
                {...props}
                type="button"
                className={` px-4 py-2 flex items-center gap-2 ${w}  justify-between ${textColor}`}
            >
                <span className="flex items-center justify-center gap-2">
                    {icon && <span className={`${iconClassName} leading-[0px]  `}>{icon}</span>}
                    {name}
                </span>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.412691 3.18382L4.02209 6.79322C4.56559 7.33672 5.44356 7.33672 5.98706 6.79322L9.59646 3.18382C10.4605 2.30586 9.8473 0.800781 8.60701 0.800781L1.40214 0.800781C0.147908 0.800781 -0.465272 2.30586 0.412691 3.18382Z"
                            fill="#969696"
                        />
                    </svg>
                </span>
            </button>
        </GradientBorder>
    );
};

export default ButtonGreen;
